export default __webpack_public_path__ + "static/media/icon-table-apu.a126ef03.svg";